// Frases dinámicas del panel hero del login (panel teal de la izquierda).
// Cada `headline` + `subtitle` describe una faceta de Agio Hub como
// plataforma central del ecosistema Agiotech. Se elige una al azar en
// cada carga de la pantalla, de modo que el login se sienta "vivo".
//
// Para agregar o quitar frases basta con editar este arreglo: el picker
// tolera cualquier cantidad (incluso vacío). Mantén el tono en español
// neutro / mexicano (tú-form), sin voseo.
export const AUTH_PHRASES = [
  {
    headline: 'Todas tus herramientas, en un solo lugar.',
    subtitle:
      'Tableros, validación, reportes y apps del ecosistema Agiotech, con un único inicio de sesión.',
  },
  {
    headline: 'El centro de tu operación Agiotech.',
    subtitle:
      'Entra una vez y accede a cada app, tablero y reporte sin volver a autenticarte.',
  },
  {
    headline: 'Una plataforma. Todo el ecosistema.',
    subtitle: 'Conecta tus apps, tus datos y tu equipo bajo una misma identidad.',
  },
  {
    headline: 'Del taller al tablero, todo conectado.',
    subtitle: 'Operación, reparación y analítica integradas en un mismo hub.',
  },
  {
    headline: 'Datos y decisiones en tiempo real.',
    subtitle:
      'Indicadores y tableros operativos siempre a la mano, desde cualquier dispositivo.',
  },
  {
    headline: 'Acceso seguro, permisos claros.',
    subtitle:
      'Un solo inicio de sesión para todas tus apps, con control y auditoría centralizados.',
  },
  {
    headline: 'Tu trabajo, sin fricción.',
    subtitle: 'Inicia sesión y retoma justo donde lo dejaste.',
  },
  {
    headline: 'Inventario, reparación y validación en un solo flujo.',
    subtitle:
      'Gestiona la operación de Agiotech desde el navegador o tu equipo preferido.',
  },
]

/**
 * Devuelve una frase del arreglo al azar. Si la lista está vacía regresa
 * una frase neutra para no romper el render del hero.
 * @param {{headline: string, subtitle: string}[]} list
 */
export function pickAuthPhrase(list = AUTH_PHRASES) {
  if (!Array.isArray(list) || list.length === 0) {
    return { headline: 'Bienvenido a Agio Hub.', subtitle: '' }
  }
  const i = Math.floor(Math.random() * list.length)
  return list[i]
}
